import {LawIcon, StarIcon} from '@primer/octicons-react'

import {isFeatureEnabled} from '@github-ui/feature-flags'

import type {McpDetails} from '../../../../types'

import {formatMcpName} from '../../../../utilities/format-mcp-name'

import {InstallButton} from '../../../../components/InstallButton/InstallButton'
import {LanguageColorDot} from '../../../../components/LanguageColorDot'

import styles from './About.module.css'

type Props = {
  mcp: McpDetails
}

export function About({mcp}: Props) {
  const isMcpRegistryInstallEnabled = isFeatureEnabled('mcp_registry_install')

  const owner = mcp.name_with_owner ? mcp.name_with_owner.split('/')[0] : null

  return (
    <div className={styles.about}>
      <div className={styles.heading}>
        {mcp.owner_avatar_url ? (
          <div className={styles.logoContainer}>
            <img src={mcp.owner_avatar_url} alt={`${mcp.name} logo`} className={styles.logo} />
          </div>
        ) : null}

        <p className={styles.name}>{mcp.display_name ?? formatMcpName(mcp.name)}</p>
      </div>

      <div className={styles.description}>
        <p className={styles.text}>{mcp.description}</p>

        {owner ? (
          <p className={styles.text}>
            By <a href={`https://github.com/${owner}`}>{owner}</a>
          </p>
        ) : null}
      </div>

      <div className={styles.metadata}>
        {mcp.primary_language ? (
          <span className={styles.group}>
            <LanguageColorDot color={mcp.primary_language_color} />
            {mcp.primary_language}
          </span>
        ) : null}

        {mcp.stargazer_count ? (
          <span className={styles.group}>
            <StarIcon size={16} />
            {mcp.stargazer_count.toLocaleString()}
          </span>
        ) : null}

        {mcp.license ? (
          <span className={styles.group}>
            <LawIcon size={16} />
            {mcp.license}
          </span>
        ) : null}
      </div>

      {isMcpRegistryInstallEnabled ? <InstallButton mcp={mcp} /> : null}
    </div>
  )
}

try{ About.displayName ||= 'About' } catch {}